import { ProductAdditives } from '../../../../services/exports/Constants';

export default {
  title: 'Aditivos',
  options: {
    [ProductAdditives.AcesulfamK]: 'Acesulfame K',
    [ProductAdditives.AceSucralose]: 'Ace-Sucralose',
    [ProductAdditives.Aesculin]: 'Esculina',
    [ProductAdditives.Agar]: 'Ágar',
    [ProductAdditives.Anthocyanin]: 'Antocianina',
    [ProductAdditives.Antioxidant]: 'Antioxidante',
    [ProductAdditives.AntioxidantAscorbicAcid]: 'Antioxidante: Ácido Ascórbico',
    [ProductAdditives.AntioxidantTocopherols]: 'Antioxidante: Tocoferóis',
    [ProductAdditives.Flavor]: 'Aroma',
    [ProductAdditives.Flavors]: 'Aromas',
    [ProductAdditives.AscorbicAcid]: 'Ácido Ascórbico',
    [ProductAdditives.Aspartame]: 'Aspartame',
    [ProductAdditives.OysterSauce]: 'Molho de Ostra',
    [ProductAdditives.BakingAid]: 'Auxiliar de Cozedura',
    [ProductAdditives.BakingPowder]: 'Fermento em Pó',
    [ProductAdditives.BalsamicVinegar]: 'Vinagre Balsâmico',
    [ProductAdditives.BalsamicCream]: 'Creme Balsâmico',
    [ProductAdditives.BasilPesto]: 'Pesto de Manjericão',
    [ProductAdditives.BenzoicAcid]: 'Ácido Benzóico',
    [ProductAdditives.BetaCarotene]: 'Beta-Caroteno',
    [ProductAdditives.Betain]: 'Betaína',
    [ProductAdditives.BeetrootRed]: 'Vermelho de Beterraba',
    [ProductAdditives.Beeswax]: 'Cera de Abelha',
    [ProductAdditives.Bitters]: 'Bitters',
    [ProductAdditives.BlueCuracao]: 'Blue Curaçao',
    [ProductAdditives.BlueCuracaoSyrup]: 'Xarope de Blue Curaçao',
    [ProductAdditives.BrandyVinegar]: 'Vinagre de Brandy',
    [ProductAdditives.Broth]: 'Caldo',
    [ProductAdditives.Caffeine]: 'Cafeína',
    [ProductAdditives.Calcium]: 'Cálcio',
    [ProductAdditives.Caramel]: 'Caramelo',
    [ProductAdditives.CaramelColor]: 'Corante de Caramelo',
    [ProductAdditives.CaramelE150d]: 'Caramelo E150d',
    [ProductAdditives.Carotene]: 'Caroteno',
    [ProductAdditives.CayennePepper]: 'Pimenta Caiena',
    [ProductAdditives.Chili]: 'Chili',
    [ProductAdditives.ChiliDressing]: 'Molho Chili',
    [ProductAdditives.ChiliMayonnaise]: 'Maionese de Chili',
    [ProductAdditives.ChiliOil]: 'Óleo de Chili',
    [ProductAdditives.Quinine]: 'Quinino',
    [ProductAdditives.Chlorophyll]: 'Clorofila',
    [ProductAdditives.CitricAcid]: 'Ácido Cítrico',
    [ProductAdditives.CitrusAcid]: 'Ácido de Citrinos',
    [ProductAdditives.CarbonDioxide]: 'Dióxido de Carbono (CO₂)',
    [ProductAdditives.CocktailSauce]: 'Molho Cocktail',
    [ProductAdditives.Curry]: 'Caril',
    [ProductAdditives.CurryPaste]: 'Pasta de Caril',
    [ProductAdditives.CurryPowder]: 'Pó de Caril',
    [ProductAdditives.CurryCreamSauce]: 'Molho Cremoso de Caril',
    [ProductAdditives.Fragrance]: 'Fragrância',
  },
};
